// src/common/components/leadFeature/LeadFeature.tsx

import React from 'react'
import { MdCheckCircle, MdError, MdHourglassEmpty } from 'react-icons/md'
import styles from './LeadFeature.module.scss'
import { Link } from 'react-router-dom'
import { useLeadFeature } from './useLeadFeature'
import {
  PERSONAL_DATA_AGREEMENT_ROUTE,
  PRIVACY_POLICY_ROUTE,
  USER_AGREEMENT_ROUTE,
} from '../../../../common/utils/constants'
import { Input } from '../../../../common/components/input/Input'
import { Button } from '../../../../common/components/button/Button'
import { Toggle } from '../../../../common/components/toggle/Toggle'
import { LeadFormStage } from '../../../../common/types/enums'
import { v4 } from 'uuid'

interface LeadFeatureProps {
  title?: string
  description?: string
  buttonText?: string
  background?: 'light' | 'gray'
  reversed?: boolean
  onSuccess?: () => void
}

export const LeadFeature: React.FC<LeadFeatureProps> = ({
  title = 'Готовы начать?',
  description = 'Оставьте телефон, и мы запустим ваш онлайн-канал продаж за 10 дней',
  buttonText = 'Получить консультацию',
  background = 'gray',
  reversed = false,
  onSuccess,
}) => {
  const {
    data,
    inputHandler,
    setDirty,
    getValidationResult,
    disabled,
    stage,
    message,
    toggleConsent,
    formAction,
  } = useLeadFeature({ onSuccess })

  const consentText = (
    <>
      Согласие с{' '}
      <Link  to={PRIVACY_POLICY_ROUTE}>
        политикой конфиденциальности
      </Link>
      ,{' '}
      <Link  to={PERSONAL_DATA_AGREEMENT_ROUTE}>
        соглашением об обработке персональных данных
      </Link>{' '}
      и{' '}
      <Link to={USER_AGREEMENT_ROUTE}>
        пользовательским соглашением
      </Link>
    </>
  )

  if (stage === LeadFormStage.SUCCESS) {
    return (
      <div className={`${styles.container} ${styles[background]}`}>
        <div className={styles.statusBlock}>
          <MdCheckCircle size={48} className={styles.successIcon} />
          <div className={styles.statusTitle}>Спасибо!</div>
          <div className={styles.statusText}>{message}</div>
        </div>
      </div>
    )
  }

  if (stage === LeadFormStage.ERROR) {
    return (
      <div className={`${styles.container} ${styles[background]}`}>
        <div className={styles.statusBlock}>
          <MdError size={48} className={styles.errorIcon} />
          <div className={styles.statusTitle}>Ошибка</div>
          <div className={styles.statusText}>{message}</div>
        </div>
      </div>
    )
  }

  if (stage === LeadFormStage.PROGRESS) {
    return (
      <div className={`${styles.container} ${styles[background]}`}>
        <div className={styles.statusBlock}>
          <MdHourglassEmpty size={48} className={styles.progressIcon} />
          <div className={styles.statusText}>{message}</div>
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.container} ${styles[background]} ${reversed ? styles.reversed : ''}`}>
      <div className={styles.contentLeft}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>

      <div className={styles.contentRight}>
        <Input
          type="tel"
          value={data.phone}
          placeHolder="Введите телефон"
          onChangeHandler={inputHandler}
          onBlur={() => setDirty('phone')}
          fieldName="phone"
          itemValidationResult={getValidationResult('phone')}
        />

        <div className={styles.consentRow}>
          <div className={styles.consent}>
            <Toggle id={v4()} onChange={toggleConsent} checked={data.consent} />
            <div className={styles.textContainer}>
              <div className={styles.consentText}>{consentText}</div>
            </div>
          </div>
        </div>

        <Button
          text={buttonText}
          disabled={disabled}
          timeoutMs={1000}
          onClick={formAction}
        />
      </div>
    </div>
  )
}